export enum PackageType {
    PublicEnrollment = 5
}